import { render, staticRenderFns } from "./ShippingAddresses.vue?vue&type=template&id=067fd3de&scoped=true&"
import script from "./ShippingAddresses.vue?vue&type=script&lang=js&"
export * from "./ShippingAddresses.vue?vue&type=script&lang=js&"
import style0 from "./ShippingAddresses.vue?vue&type=style&index=0&id=067fd3de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067fd3de",
  null
  
)

export default component.exports